import { createFillHandleEffect } from '@databases/selections';
import { type DatabaseAdapter } from '@databases/selections-api-types';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface FillHandleEffectFeatureDeps {
  databaseAdapter: DatabaseAdapter;
}

export function createFillHandleEffectFeature({
  databaseAdapter,
}: FillHandleEffectFeatureDeps): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FILL_HANDLE_EFFECT,
    type: 'effect',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE && ctx.permissions.canEditContent,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFillHandleEffect({
        controller: highlightsController,
        getVisibleEntryCount: () => databaseAdapter.getVisibleEntryCount(),
      });
    },
  };
}
